// 현재 창의 회사 id — URL 쿼리 ?company=id 에서 읽는다(창별 독립).
// 비-React 컨텍스트(api 클라이언트 등)에서도 안전하게 사용.
export function currentCompanyId(): number | null {
  try {
    const v = new URLSearchParams(window.location.search).get('company')
    const n = v ? Number(v) : NaN
    return Number.isFinite(n) && n > 0 ? n : null
  } catch {
    return null
  }
}
